import { useState } from "react";
import { useScheduleEventStore } from "../../hooks";
import {
  PatientSurgeryResultsTable,
  PatientSurgeryAssessmentMadeTable,
} from "../tables";
import { PatientSurgeryAssessmentForm } from "../forms";
import { PatientSurgeryEvaluationAccordion } from "../accordions";
import {
  PatientSurgeryProcedureInfoCard,
  PatientSurgeryNotPresentAssessmentCard,
  PatientSurgeryExamResultsCard,
  PatientSurgeryFinalAssessmentCard,
} from "./";

const assessmentStates = ["SCHEDULED_ASSESSMENT", "RESCHEDULED_ASSESSMENT"];

const assessmentMadeStates = [
  "ASSESSMENT_MADE",
  "ASSESSMENT_MADE_RESCHEDULE",
  "QUIZ_SATISFACTION_ANSWERED",
  "SCHEDULED_ASSESSMENT_FINAL",
  "FINISHED",
];

const notPresentAssessmentStates = ["ASSESSMENT_NO_SHOW"];

const finalAssessmentStates = [
  "SCHEDULED_ASSESSMENT_FINAL",
  "QUIZ_SATISFACTION_ANSWERED",
  "FINISHED",
];

export const PatientSurgeryInfocard = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    scheduleEvent,
  } = useScheduleEventStore();

  const { patientSurgery, eventFiles, type, attended } = scheduleEvent;

  // States ------------------------------------------------//
  const [activeIndex, setActiveIndex] = useState(1);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <div className="w-full">
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <button
            className={`nav-link ${activeIndex === 1 ? "active" : ""}`}
            aria-current="page"
            onClick={() => setActiveIndex(1)}
          >
            Encuesta
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeIndex === 2 ? "active" : ""}`}
            aria-current="page"
            onClick={() => setActiveIndex(2)}
          >
            Resultados
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeIndex === 3 ? "active" : ""}`}
            aria-current="page"
            onClick={() => setActiveIndex(3)}
          >
            Valoración
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeIndex === 4 ? "active" : ""}`}
            aria-current="page"
            onClick={() => setActiveIndex(4)}
          >
            Exámenes médicos
          </button>
        </li>
      </ul>
      <div className="card">
        <div className="card-body">
          {activeIndex === 1 && (
            <PatientSurgeryEvaluationAccordion
              evaluations={patientSurgery.evaluations.EVALUATION}
            />
          )}
          {activeIndex === 2 && (
            <div className="vstack gap-4">
              <PatientSurgeryProcedureInfoCard
                patientSurgery={patientSurgery}
              />
              <PatientSurgeryResultsTable patientSurgery={patientSurgery} />
            </div>
          )}
          {activeIndex === 3 && (
            <>
              {assessmentStates.includes(patientSurgery.state) && (
                <PatientSurgeryAssessmentForm patientSurgery={patientSurgery} />
              )}
              {assessmentMadeStates.includes(patientSurgery.state) && (
                <PatientSurgeryAssessmentMadeTable
                  patientSurgery={patientSurgery}
                />
              )}
              {notPresentAssessmentStates.includes(patientSurgery.state) && (
                <PatientSurgeryNotPresentAssessmentCard />
              )}
              {finalAssessmentStates.includes(patientSurgery.state) && (
                <PatientSurgeryFinalAssessmentCard attended={attended} />
              )}
            </>
          )}
          {activeIndex === 4 && (
            <PatientSurgeryExamResultsCard eventFiles={eventFiles} />
          )}
        </div>
      </div>
    </div>
  );
};
